<div class="text-center" *ngIf="this.productDetails.loading">
    <div class="loader"></div>
</div>

<div class="themeAlert danger" *ngIf="this.productDetails.error">
    {{this.productDetails.error}}
</div>

<form [formGroup]="form" (ngSubmit)="onSubmit()" *ngIf="!this.productDetails.loading && !this.productDetails.error">
    <div class="frmbbxx">
        <!-- <div class="loader"></div> -->
        <app-main-heading [title]="this.formTitle"></app-main-heading>
        <div class="productPoup1">
            <div class="row">
                <div class="col-lg-4">
                    <div class="inputGroup">
                        <input maxlength="64" type="text"
                            formControlName="productName"
                            class="inputBox {{form.get('productName')?.errors && form.get('productName')?.touched ? 'border-danger' : ''}}"
                            id="productName" placeholder="" />
                            <label for="productName" class="inputLabel popInLabel">Product Name</label>
                            <small class="text-right d-block">{{countChars(form.get('productName')?.value)}}/64</small>
                        <small class="text-danger"
                            *ngIf="form.get('productName')?.hasError('required') && form.get('productName')?.touched">
                            Product Name is required.
                        </small>
                        <small class="text-danger"
                            *ngIf="form.get('productName')?.hasError('maxlength') && form.get('productName')?.touched">
                            Product name can't be more than
                            {{form.get('productName')?.errors?.['maxlength']?.requiredLength}} chars.
                        </small>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="inputGroup">
                        <mat-form-field
                            class="w-100 mat-input-group {{form.get('categoryId')?.hasError('required') && form.get('categoryId')?.touched ? 'border-danger' : ''}}"
                            appearance="outline">
                            <mat-label class="matLabel">Category </mat-label>
                            <mat-select formControlName="categoryId">
                                <mat-option [value]="" *ngIf="categoryList.loading"><i>Loading ...</i></mat-option>
                                <mat-option *ngFor="let category of categoryList.response" [value]="category.id">
                                    {{ category.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <small class="text-danger"
                            *ngIf="form.get('categoryId')?.hasError('required') && form.get('categoryId')?.touched">
                            Category is required.
                        </small>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="inputGroup">
                        <mat-form-field
                            class="w-100 mat-input-group {{form.get('subCategoryId')?.hasError('required') && form.get('subCategoryId')?.touched ? 'border-danger' : ''}}"
                            appearance="outline">
                            <mat-label class="matLabel">Sub Category </mat-label>
                            <mat-select formControlName="subCategoryId">
                                <mat-option [value]="" *ngIf="subCategoryList.loading"><i>Loading ...</i></mat-option>
                                <mat-option *ngFor="let subCategory of subCategoryList.response"
                                    [value]="subCategory.id">
                                    {{ subCategory.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <small class="text-danger"
                            *ngIf="form.get('subCategoryId')?.hasError('required') && form.get('subCategoryId')?.touched">
                            Sub Category is required.
                        </small>
                    </div>
                </div>
                <div class="col-lg-8">
                    <div class="inputGroup">
                        <textarea id="addreg" formControlName="description" maxlength="80"
                            class="{{form.get('description')?.errors && form.get('description')?.touched ? 'border-danger' : ''}}"
                            rows="8" placeholder="" class="inputBox regTextarea prodModelAreaheight"></textarea>
                            <label for="addreg" class="inputLabel popInLabel">Write something...</label>
                            <small class="text-right d-block">{{countChars(form.get('description')?.value)}}/80</small>
                        <small class="text-danger"
                            *ngIf="form.get('description')?.hasError('required') && form.get('description')?.touched">
                            Description is required.
                        </small>
                        <small class="text-danger"
                            *ngIf="form.get('description')?.hasError('maxlength') && form.get('description')?.touched">
                            Description can't be more than
                            {{form.get('description')?.errors?.['maxlength']?.requiredLength}} chars.
                        </small>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="inputGroup">
                                <mat-form-field
                                    class="w-100 mat-input-group {{form.get('availableBranches')?.hasError('required') && form.get('availableBranches')?.touched ? 'border-danger' : ''}}"
                                    appearance="outline">
                                    <mat-label class="matLabel">Available Branches </mat-label>
                                    <!-- <input *ngIf="this.viewMode" matInput
                                    [value]="this.selectedAvilableBranchesToShow(selectedAvilableBranches)" [readonly]="true"> -->
                                    <mat-select formControlName="availableBranches" [compareWith]="comparer" multiple
                                        [(ngModel)]="this.selectedAvilableBranches">
                                        <mat-option [value]="" *ngIf="availableBranchesList.loading"><i>Loading
                                                ...</i></mat-option>
                                        <!-- <mat-option [value]=null *ngIf="!availableBranchesList.loading">All branches</mat-option> -->
                                        <mat-option *ngFor="let ab of availableBranchesList.response"
                                            [value]="{id:ab.id}">
                                            <!-- {{ ab.branchName }} {{ ab.address }}, {{ ab.city }}, {{ ab.state }}, {{
                                            ab.pincode }} -->
                                            {{ab.branchName}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <small class="text-danger"
                                    *ngIf="form.get('availableBranches')?.hasError('required') && form.get('availableBranches')?.touched">
                                    Available Branches is required.
                                </small>
                            </div>
                        </div>
                        <div class="col-lg-12">
                            <div class="row">
                                <div class="col-lg-6">
                                    <div class="inputGroup">
                                        <input (keypress)="this.allowOnlyNumeric($event)" type="tel"
                                            formControlName="weight" maxlength="6"
                                            class="inputBox {{form.get('weight')?.hasError('required') && form.get('weight')?.touched ? 'border-danger' : ''}}"
                                            id="weight" placeholder="" />
                                        <label for="weight" class="inputLabel popInLabel">
                                            Weight
                                        </label>
                                        <small class="text-danger"
                                            *ngIf="form.get('weight')?.hasError('required') && form.get('weight')?.touched">
                                            Weight is required.
                                        </small>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="inputGroup">
                                        <mat-form-field
                                            class="w-100 mat-input-group {{form.get('weightUnitId')?.hasError('required') && form.get('weightUnitId')?.touched ? 'border-danger' : ''}}"
                                            appearance="outline">
                                            <mat-label class="matLabel">Weight Unit </mat-label>
                                            <mat-select formControlName="weightUnitId">
                                                <mat-option *ngFor="let weightUnit of weightUnitList.response"
                                                    [value]="weightUnit.id">
                                                    {{ weightUnit.name }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <small class="text-danger"
                                            *ngIf="form.get('weightUnitId')?.hasError('required') && form.get('weightUnitId')?.touched">
                                            Weight unit is required.
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="inputGroup">
                        <mat-form-field
                            class="w-100 mat-input-group {{form.get('delDistanceId')?.hasError('required') && form.get('delDistanceId')?.touched ? 'border-danger' : ''}}"
                            appearance="outline">
                            <mat-label class="matLabel">Del. Distance </mat-label>
                            <mat-select formControlName="delDistanceId">
                                <mat-option [value]="" *ngIf="delDistanceList.loading"><i>Loading ...</i></mat-option>
                                <mat-option *ngFor="let delDistance of delDistanceList.response"
                                    [value]="delDistance.id">
                                    {{ delDistance.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <small class="text-danger"
                            *ngIf="form.get('delDistanceId')?.hasError('required') && form.get('delDistanceId')?.touched">
                            Del. distance is required.
                        </small>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="inputGroup">
                        <mat-form-field
                            class="w-100 mat-input-group {{form.get('productTypeId')?.hasError('required') && form.get('productTypeId')?.touched ? 'border-danger' : ''}}"
                            appearance="outline">
                            <mat-label class="matLabel">Product Type </mat-label>
                            <mat-select formControlName="productTypeId">
                                <mat-option [value]="" *ngIf="prodTypeList.loading"><i>Loading ...</i></mat-option>
                                <mat-option *ngFor="let productTypeId of prodTypeList.response"
                                    [value]="productTypeId.id">
                                    {{ productTypeId.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <small class="text-danger"
                            *ngIf="form.get('productTypeId')?.hasError('required') && form.get('productTypeId')?.touched">
                            Product type is required.
                        </small>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="inputGroup">
                        <mat-form-field
                            class="w-100 mat-input-group {{form.get('packingTypeId')?.hasError('required') && form.get('packingTypeId')?.touched ? 'border-danger' : ''}}"
                            appearance="outline">
                            <mat-label class="matLabel">Packing Type </mat-label>
                            <mat-select formControlName="packingTypeId">
                                <mat-option [value]="" *ngIf="packingTypeList.loading"><i>Loading ...</i></mat-option>
                                <mat-option *ngFor="let packingTypeId of packingTypeList.response"
                                    [value]="packingTypeId.id">
                                    {{ packingTypeId.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <small class="text-danger"
                            *ngIf="form.get('packingTypeId')?.hasError('required') && form.get('packingTypeId')?.touched">
                            Packing type is required.
                        </small>
                    </div>
                </div>
                <div class="col-lg-12">
                    <div class="imgUploadTitle">Upload Product photo</div>
                    <div class="imageUploadSec">

                        <div class="imageUpload me-2" *ngFor="let ml of mediaList?.value; index as k">
                            <label class="shadow-1" formArrayName="mediaList" for="mlmm{{k}}"
                                class="border {{!ml?.src && k === 0 && form.get('mediaList')?.touched ? 'border-danger' : ''}}">
                                <input hidden *ngIf="!this.uploadingFile" type="file" id="mlmm{{k}}"
                                    accept=".png,.jpg,.jpeg"
                                    (input)="this.uploadFileWhileEdit($event.target, 'media', k)" />
                                <img src="{{ml?.src}}" *ngIf="!(this.uploadingMediaIndex === k && this.uploadingFile)"
                                    onerror="this.src = '../../../assets/images/upload-img.svg';" alt=""
                                    style="height: 50px;" />
                                <div *ngIf="this.uploadingMediaIndex === k">
                                    <div class="loader"></div>
                                </div>
                            </label>
                            <button class="action" *ngIf="ml?.src" (click)="this.removeMedia(k)">
                                <img src="./assets/images/trash-icon.svg" alt="" />
                            </button>
                        </div>

                    </div>
                    <div class="imgUploadText">
                        *Recommended resolution is 640×640 with file size {{this.allowedFileSizeToUpload}} MB
                    </div>
                </div>
                <div class="tablebox customScroll">
                    <div class="text-center" *ngIf="this.subCategoryVarientList.loading">
                        <div class="loader"></div>
                    </div>
                    <table class="table addtbl" formArrayName="variantList"
                        *ngIf="this.subCategoryVarientList.response?.length">
                        <tr>
                            <th>S. No</th>
                            <th>SKU OR BARCODE or Variant name</th>
                            <th>Quantity</th>
                            <th>Stock Status</th>
                            <th>Status</th>
                            <th *ngFor="let vt of this.subCategoryVarientList.response; index as in">Attribute {{in+1}}
                            </th>
                            <th>MRP</th>
                            <th>Discounted Price</th>
                            <th>Variant photo</th>
                            <th>Delete</th>
                        </tr>
                        <tr *ngFor="let variant of variantControls; index as i">
                            <td [formGroupName]="i">{{i+1}}</td>
                            <td [formGroupName]="i">
                                <div class="inputGroup">
                                    <input (keypress)="this.allowOnlyNumeric($event)" type="text" formControlName="sku"
                                        maxlength="19"
                                        class="inputBox {{variant.get('sku')?.errors && variant.get('sku')?.touched ? 'border-danger' :''}}"
                                        id="sku{{i}}" placeholder="" />
                                    <label for="sku{{i}}" class="inputLabel popInLabel">
                                        SKU OR BARCODE
                                    </label>
                                    <small class="text-danger d-block text-start"
                                        *ngIf="variant.get('sku')?.hasError('required') && variant.get('sku')?.touched">
                                        SKU is required.
                                    </small>
                                </div>
                            </td>
                            <td [formGroupName]="i">
                                <div class="inputGroup">
                                    <input (keypress)="this.allowOnlyNumeric($event)" type="tel"
                                        formControlName="quantity" maxlength="4"
                                        class="inputBox {{variant.get('quantity')?.errors && variant.get('quantity')?.touched ? 'border-danger' :''}}"
                                        id="quantity{{i}}" placeholder="" />
                                    <label for="quantity{{i}}" class="inputLabel popInLabel">Quantity</label>
                                    <small class="text-danger d-block text-start"
                                        *ngIf="variant.get('quantity')?.hasError('required') && variant.get('quantity')?.touched">
                                        Quantity is required.
                                    </small>
                                </div>
                            </td>
                            <td [formGroupName]="i">
                                <div class="inputGroup">
                                    <mat-form-field
                                        class="w-100 mat-input-group {{variant.get('stockStatusId')?.errors && variant.get('stockStatusId')?.touched ? 'border-danger' :''}}"
                                        appearance="outline">
                                        <mat-label class="matLabel">Stock
                                            Status </mat-label>
                                        <mat-select formControlName="stockStatusId">
                                            <mat-option *ngFor="let stockStatus of stockStatusList.response"
                                                [value]="stockStatus.id">
                                                {{ stockStatus.status }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <small class="text-danger d-block text-start"
                                        *ngIf="variant.get('stockStatusId')?.hasError('required') && variant.get('stockStatusId')?.touched">
                                        Stock status is required.
                                    </small>
                                </div>
                            </td>
                            <td [formGroupName]="i">
                                <div class="inputGroup">
                                    <mat-form-field
                                        class="w-100 mat-input-group {{variant.get('statusId')?.errors && variant.get('statusId')?.touched ? 'border-danger' :''}}"
                                        appearance="outline">
                                        <mat-label class="matLabel">Status </mat-label>
                                        <mat-select formControlName="statusId">
                                            <mat-option *ngFor="let status of statusList.response" [value]="status.id">
                                                {{ status.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                    <small class="text-danger d-block text-start"
                                        *ngIf="variant.get('statusId')?.hasError('required') && variant.get('statusId')?.touched">
                                        Status is required.
                                    </small>
                                </div>
                            </td>
                            <td [formGroupName]="i"
                                *ngFor="let vt of this.subCategoryVarientList.response; index as in">
                                <div class="inputGroup">
                                    <mat-form-field class="w-100 mat-input-group" appearance="outline">
                                        <mat-label class="matLabel">{{vt.name}} </mat-label>
                                        <mat-select formControlName="variantOption{{in+1}}">
                                            <mat-option *ngFor="let vo of vt.options; index as in"
                                                [value]="vo.variant_option_value">{{vo.variant_option_value}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </td>
                            <td [formGroupName]="i">
                                <div class="inputGroup">
                                    <input (keypress)="this.allowOnlyNumeric($event)" type="tel" formControlName="price"
                                        maxlength="6"
                                        class="inputBox {{variant.get('price')?.errors && variant.get('price')?.touched ? 'border-danger' : ''}}"
                                        id="price{{i}}" placeholder="" />
                                    <label for="price{{i}}" class="inputLabel popInLabel">MRP
                                    </label>
                                    <small class="text-danger d-block text-start"
                                        *ngIf="variant.get('price')?.hasError('required') && variant.get('price')?.touched">
                                        Price is required.
                                    </small>
                                    <small class="text-danger d-block text-start"
                                    *ngIf="variant.get('price')?.hasError('min') && variant.get('price')?.touched">
                                    Price can't be 0.
                                </small>
                                </div>
                            </td>
                            <td [formGroupName]="i">
                                <div class="inputGroup">
                                    <input (keypress)="this.allowOnlyNumeric($event)" type="tel" maxlength="6"
                                        formControlName="discountedPrice"
                                        class="inputBox {{variant.get('discountedPrice')?.errors && variant.get('discountedPrice')?.touched ? 'border-danger' : ''}}"
                                        id="discountedPrice{{i}}" placeholder="" style="width: 200px;" />
                                    <label for="discountedPrice{{i}}" class="inputLabel popInLabel">Discounted
                                        Price</label>
                                    <small class="text-danger d-block text-start"
                                        *ngIf="variant.get('discountedPrice')?.hasError('required') && variant.get('discountedPrice')?.touched">
                                        Discounted price is required.
                                    </small>
                                    <small class="text-danger d-block text-start"
                                    *ngIf="variant.get('discountedPrice')?.hasError('moreThanPrice') && variant.get('discountedPrice')?.touched">
                                    Must be less than MRP.
                                </small>
                                </div>
                            </td>
                            <td [formGroupName]="i">
                                <div class="position-relative"
                                    *ngFor="let vm of variant.get('mediaList')?.value; index as j">
                                    <label class="shadow-1" formArrayName="mediaList" for="medial{{i}}">
                                        <input hidden *ngIf="!this.uploadingFile" type="file" id="medial{{i}}"
                                            accept=".png,.jpg,.jpeg"
                                            (input)="this.uploadFileWhileEdit($event.target, 'varient', i)" />
                                        <img src="{{vm?.src}}"
                                            *ngIf="!(this.uploadingVarientMediaIndex === i && this.uploadingFile)"
                                            onerror="this.src = '../../../assets/images/upload-img.svg';" alt=""
                                            style="height: 50px;" />
                                        <div *ngIf="this.uploadingVarientMediaIndex === i">
                                            <div class="loader"></div>
                                        </div>
                                    </label>
                                    <button class="action" *ngIf="vm.src" (click)="this.removeVariantMedia(i,j)">
                                        <img src="./assets/images/trash-icon.svg" alt="" />
                                    </button>
                                </div>
                            </td>
                            <td><button class="action" (click)="this.removeVariant(i, variant.get('id')?.value)">
                                    <img src="./assets/images/trash-icon.svg" alt="" />
                                </button></td>
                        </tr>
                    </table>
                </div>
                <div class="aabtn d-block text-start mt-4" *ngIf="this.subCategoryVarientList.response?.length">
                    <span class="btnTextPluse cursor-pointer" (click)="this.addVariant()">+ Add another option</span>
                </div>
            </div>
        </div>
        <div class="text-center d-block mb-2">
            <div class="btnbx modPopBtns mt-3">
                <button type="button" class="btnThemeOutline blue me-3 modelPopup-btn"
                    [disabled]="this.submitLoading || this.uploadingFile" (click)="this.handleReset()">
                    Cancel
                </button>
                <button class="gredientOutLineBtn" [disabled]="this.submitLoading || this.uploadingFile">
                    <!-- <div class="loader" *ngIf="this.submitLoading"></div>
                    <div class="btnContent modelPopup-btn" *ngIf="!this.submitLoading">Update </div> -->
                    <div class="btnContent modelPopup-btn">
                        <div class="loader small" *ngIf="this.submitLoading"></div>
                        <div *ngIf="!this.submitLoading">Update</div>
                    </div>
                </button>
            </div>
        </div>
    </div>
</form>